<template>
  <div class="blkDocCreation">
    <!-- Form thêm và xem chi tiết ở chờ xác nhận vb đến-->
    <div class="form-info">
      <el-form ref="form" :model="form" :rules="validationRules" inline-message>
        <div class="group__info has-border__bottom padding-bottom-10">
          <div class="title font-size__medium">
            Thông tin vào sổ
          </div>
          <div class="content">
            <div class="form-input">
              <el-form-item
                class="custom-label__input margin-bottom-5"
                prop="bookId"
              >
                <span class="label-input field-needed">Sổ đến</span>
                <el-select
                  clearable
                  class="style-fullWidth input-font__bold input-border__bottom input-border__radius__0"
                  v-model="form.bookId"
                  ref="selectBook"
                  filterable
                  placeholder="-"
                  @change="docInBookInfoChangedForBookNumberWhenTuChoi()"
                >
                  <el-option
                    v-for="item in books"
                    :key="item.id"
                    :label="item.bookName"
                    :value="item.id"
                  ></el-option>
                </el-select>
              </el-form-item>
              <!--              <div class="flex-row flex__left">-->
              <el-row :gutter="20">
                <el-col :span="isShowSoPhu || form.subBookNumber ? 12 : 14">
                  <el-form-item
                    prop="bookNumber"
                    class="custom-label__multiple__element"
                  >
                    <span class="label-input">Số đến: </span>
                    <el-input-number
                      class="style-fullWidth input-font__bold"
                      v-model="form.bookNumber"
                      size="mini"
                      :min="1"
                      :max="1000000"
                      :disabled="!isFormIncomingDateEqualCurrentDate"
                    >
                    </el-input-number>
                  </el-form-item>
                </el-col>
                <el-col :span="4" v-if="isShowSoPhu || form.subBookNumber">
                  <el-form-item
                    prop="subBookNumber"
                    class="custom-label__multiple__element"
                  >
                    <span class="label-input width__auto">Số phụ: </span>
                    <el-input
                      class="style-fullWidth input-font__bold"
                      v-model="form.subBookNumber"
                      size="mini"
                      :disabled="true"
                    >
                    </el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="isShowSoPhu || form.subBookNumber ? 8 : 10">
                  <el-form-item
                    class="custom-label__multiple__element"
                    prop="incomingDate"
                  >
                    <span class="label-input field-needed width__auto"
                    >Ngày đến</span
                    >
                    <el-date-picker
                      class="style-fullWidth input-bg__transparent input-font__bold input-border__bottom input-border__radius__0"
                      size="mini"
                      v-model="form.incomingDate"
                      type="date"
                      placeholder="dd/mm/yyyy"
                      :prefix-icon="' '"
                      format="dd/MM/yyyy"
                      :picker-options="incomingDatePickerOptions"
                      @change="docInBookInfoChanged()"
                    ></el-date-picker>
                  </el-form-item>
                </el-col>
              </el-row>
              <!--              </div>-->
            </div>
          </div>
        </div>
        <div class="group__info margin-top-10 padding-bottom-10">
          <div class="title font-size__medium">
            Thông tin văn bản
          </div>
          <div class="content">
            <div class="form-input">
              <div class="file-uploaded input-none__border" v-if="vbAttachment">
                <div class="file-uploaded">
                  <div class="file clickable flex-row flex__between">
                    <a
                      v-openInNewTab
                      :href="
                        getToken(vbAttachment.id)
                          | buildAttachmentURL({
                            type: DOWNLOAD_OPTION.TYPE.ORIGINAL
                          })
                      "
                      class="flex-row flex__left"
                    >
                      <fileTypeImage
                        :fileExtention="vbAttachment.fileExtention"
                        :customClass="'icon-small margin-right-10'"
                      />
                      <span class="fileName font-weight_normal">{{
                          vbAttachment.fileName
                        }}</span>
                    </a>
                    <div @click="showSignatureInfo">
                      <el-tooltip content="Xem thông tin chữ kí số(nếu có)" placement="top">
                        <i class="fas fa-signature"></i>
                      </el-tooltip>
                    </div>
                    <div v-if="!incomingDoc || isBanHanhTrucLienThong || (!incomingDoc.vbOutgoingDocId && !incomingDoc.forwardIncomingDocId && incomingDoc.creatorId === userDeptRole.userId)" @click="removeUploadAttachment">
                      <el-tooltip content="Xóa tệp" placement="top">
                        <i class="fas fa-trash-alt color__red"></i>
                      </el-tooltip>
                    </div>
                    <i
                      class="el-icon-circle-close margin-left-10 font-size__large color__red"
                      v-if="false"
                      @click="removeUploadAttachment"
                    ></i>
                  </div>
                </div>
              </div>

              <el-form-item prop="attachment" class="input-no__label" v-else-if="!incomingDoc || isBanHanhTrucLienThong || (!incomingDoc.vbOutgoingDocId && !incomingDoc.forwardIncomingDocId && incomingDoc.creatorId === userDeptRole.userId)">
                <el-upload
                  class="upload-demo style-fullWidth input-border__bottom"
                  drag
                  :action="uploadAttachmentURL"
                  size=""
                  :on-success="
                    response =>
                      onUploadSuccess(response).then(response =>
                        uploadAttachmentSuccess(response)
                      )
                  "
                  :data="uploadAttachmentAdditionalData"
                  :file-list="form.attachmentFiles"
                  :show-file-list="false"
                  :headers="uploadAttachmentHeaders"
                  :accept="DOCUMENT_FILE.ACCEPT_TYPES"
                  :before-upload="file => validateUploadFile(file)"
                  :on-error="onUploadError"
                  v-loading="isUploading"
                  :disabled="
                    !isBanHanhTrucLienThong &&
                    !(incomingDoc && incomingDoc.creatorId === userDeptRole.userId) &&
                    (form.status === INCOMING_DOC_STATUS.TAO_MOI ||
                      form.status === INCOMING_DOC_STATUS.TU_CHOI) &&
                          form.isThuHoiTatCaOrNot === 0
                  "
                >
                  <div class="el-upload__text">
                    <p class="margin-0 padding-0">Tải tệp đính kèm:</p>
                    <i class="fas fa-cloud-upload color__silver"></i>
                  </div>

                </el-upload>
              </el-form-item>

              <div class="margin-top-10 file-uploaded input-none__border" v-if="vbShareLibAttchment">
                <div class="file-uploaded">
                  <div class="file clickable flex-row flex__between">
                    <div class="flex-row flex__left">
                      <a
                        @click.prevent
                        :href="
                        getToken(vbShareLibAttchment.id)
                          | buildAttachmentURL({
                            type: DOWNLOAD_OPTION.TYPE.ORIGINAL
                          })
                      "
                        class="flex-row flex__left"
                      >
                        <fileTypeImage
                          :fileExtention="vbShareLibAttchment.fileExtention"
                          :customClass="'icon-small margin-right-10'"
                        />
                        <span class="fileName font-weight_normal">{{
                            vbShareLibAttchment.fileName
                          }}</span>
                      </a>
                    </div>
                    <div @click="isOpenDynamicFieldFormDialog = true">
                      <el-tooltip content="Điền form" placement="top">
                        <i class="fab fa-wpforms" />
                      </el-tooltip>
                    </div>
                  </div>
                </div>
              </div>



              <div class="flex-row">
                <el-button
                  class="btnPlain margin-top-5"
                  @click="openCreateTemplateFile"
                  v-if="!id && !(vbAttachment&&vbAttachment.id)"
                >
                  <i :class="['fas fa-file-word']"></i>
                  &nbsp;Soạn thảo
                </el-button>
                <el-button class="btnPlain"
                           v-if="vbAttachment&&vbAttachment.id&&!(vbAttachment.fileExtention==IS_PDF||vbAttachment.fileExtention==IS_DOC)">
                  <i :class="['fas fa-edit']" style="position: relative;top: -10px;"></i>
                  <iframe v-if="wordEditSrc" :src="wordEditSrc" width="50" height="36"
                          style="border: none;overflow:hidden;" frameborder="0"></iframe>
                </el-button>
                <el-button
                  v-if="!(vbAttachment&&vbAttachment.id)"
                  class="btnPlain"
                  @click="isOpenScanDialog=true"
                >
                  <i :class="['fas fa-search']"></i>
                  &nbsp;Scan
                </el-button>
              </div>
              <el-form-item class="custom-label__input" prop="docCode">
                <span :class="setDynamicStylingRequired(docCodeRequired)">Số ký hiệu: </span>

                <el-input
                  class="style-fullWidth input-font__bold input-border__bottom input-border__radius__0"
                  v-model="form.docCode"
                  size=""
                  placeholder="-"
                  maxlength="100"
                >
                </el-input>
              </el-form-item>

              <el-form-item class="custom-label__input" prop="docDate">
                <span class="label-input  field-needed">Ngày văn bản: </span>
                <el-date-picker
                  class="style-fullWidth input-font__bold input-border__bottom input-border__radius__0"
                  size=""
                  v-model="docDate"
                  type="date"
                  placeholder="dd/mm/yyyy"
                  :prefix-icon="' '"
                  format="dd/MM/yyyy"
                >
                </el-date-picker>
              </el-form-item>

              <el-form-item class="custom-label__input" prop="docTypeId">
                <span class="label-input">Loại văn bản: </span>
                <el-select
                  clearable
                  class="style-fullWidth input-font__bold input-border__bottom input-border__radius__0"
                  v-model="form.docTypeId"
                  size=""
                  filterable
                  @change="changeDocTypeId"
                  placeholder="-"
                >
                  <el-option
                    v-for="item in docTypes"
                    :key="item.id"
                    :label="item.categoryName"
                    :value="item.id"
                  >
                  </el-option>
                </el-select>
              </el-form-item>

              <el-form-item
                class="custom-label__input"
                prop="publisherId"
                v-if="!incomingDoc || incomingDoc.publisher"
              >
                <span class="flex-row flex__right label-input no_wrap">
                  <span>Đơn vị phát hành (bên trong)</span>
                  &nbsp;
                  <el-tooltip
                    content="Cây danh mục đơn vị"
                    placement="top"
                    effect="dark"
                  >
                    <i
                      v-if="!form.outsidePublisherName && !form.insidePublisherName"
                      class="fas fa-cog advance-search color__cyan clickable"
                      @click="isOpenSelectDepartmentDialog = true"
                    ></i>
                  </el-tooltip>
                </span>
                <el-select
                  :disabled="!!form.outsidePublisherName || !!form.insidePublisherName"
                  filterable
                  class="style-fullWidth input-font__bold input-border__bottom input-border__radius__0"
                  v-model="form.publisherId"
                  placeholder="Nhập tên đơn vị để tìm kiếm"
                  clearable
                  @change="publisherIdChange"
                >
                  <el-option
                    v-for="item in departments"
                    :label="customDeptName(item)"
                    :key="item.id"
                    :value="item.id"
                  ></el-option>
                </el-select>
              </el-form-item>
              <!--                Chỉ lấy 1 trong 3 Đơn vị phát hành (bên trong)-Đơn vị phát hành (bên ngoài)-Nơi ban hành-->
              <el-form-item class="custom-label__input" prop="insidePublisherName"
                            v-if="(!incomingDoc || incomingDoc.insidePublisherName) && tenantCode === TENANT_CODE.VINATABA">
                <span class="label-input">Nơi ban hành (bên trong):</span>
                <el-input
                  :disabled="!!form.publisherId || !!form.outsidePublisherName || !!isBanHanhTrucLienThong"
                  type="textarea"
                  rows="1"
                  maxlength="2000"
                  v-model="form.insidePublisherName"
                  placeholder="-"
                  autosize
                  resize="none"
                  @change="insidePublisherChange"
                  class="input-font__bold style-fullWidth input-border__bottom input-border__radius__0"
                ></el-input>
              </el-form-item>

              <el-form-item
                class="custom-label__input"
                v-if="!incomingDoc || incomingDoc.outsidePublisherName"
              >
                <span class="label-input">Đơn vị phát hành (bên ngoài): </span>
                <el-select
                  :disabled="!!form.publisherId || !!form.insidePublisherName|| !!isBanHanhTrucLienThong"
                  :class="[
                    'style-fullWidth input-font__bold input-border__bottom input-border__radius__0',
                    form.publisherId ? 'input-bg__transparent' : ''
                  ]"
                  v-model="form.outsidePublisherName"
                  filterable
                  allow-create
                  default-first-option
                  remote
                  reserve-keyword
                  :remote-method="remoteMethod"
                  :loading="isLoading"
                  @change="outsidePublisherChange"
                  class="style-fullWidth input-border__bottom input-border__radius__0"
                >
                  <el-option
                    v-for="(item, index) in listInsideReceiver"
                    :key="index"
                    :label="item.deptName"
                    :value="item.deptName"
                  >
                  </el-option>
                </el-select>
                <!--                <el-input-->
                <!--                    :class="[-->
                <!--                    'style-fullWidth input-font__bold input-border__bottom input-border__radius__0',-->
                <!--                    form.publisherId ? 'input-bg__transparent' : ''-->
                <!--                  ]"-->
                <!--                    v-model="form.outsidePublisherName"-->
                <!--                    size=""-->
                <!--                    placeholder="-"-->
                <!--                    maxlength="500"-->
                <!--                    @change="clearValidate()"-->
                <!--                    :disabled="form.publisherId ? true : false"-->
                <!--                >-->
                <!--                </el-input>-->
              </el-form-item>

              <el-form-item
                class="custom-label__input"
                v-if="incomingDoc && incomingDoc.forwardDeptName"
              >
                <span class="label-input">Nơi gửi: </span>
                <el-input
                  :class="[
                    'style-fullWidth input-font__bold input-border__bottom input-border__radius__0',
                    form.publisherId ? 'input-bg__transparent' : ''
                  ]"
                  v-model="incomingDoc.forwardDeptName"
                  size="mini"
                  placeholder="-"
                  maxlength="500"
                  :disabled="true"
                >
                </el-input>
              </el-form-item>

              <el-form-item class="custom-label__input" prop="quote">
                <span class="label-input field-needed">Trích yếu</span>
                <el-input
                  type="textarea"
                  rows="1"
                  maxlength="2000"
                  v-model="form.quote"
                  placeholder="-"
                  autosize
                  resize="none"
                  class="input-font__bold style-fullWidth input-border__bottom input-border__radius__0"
                ></el-input>
              </el-form-item>

              <el-form-item class="custom-label__input" prop="priorityId">
                <span class="label-input">Độ khẩn: </span>
                <multiselect
                  :class="[
                    form.priorityId ? '' : '',
                    'style-fullWidth input-font__bold',
                    'input-border__radius__0'
                  ]"
                  :options="priorities"
                  label="categoryName"
                  track-by="id"
                  :preselect-first="true"
                  v-model="priority"
                  placeholder="-"
                  :multiple="false"
                  :close-on-select="true"
                  :clear-on-select="true"
                  :searchable="true"
                  open-direction="top"
                >
                  <template slot="noResult"
                  >Không tìm thấy dữ liệu phù hợp.
                  </template>
                  <template slot="noOptions"
                  >Danh sách trống
                  </template>
                  <template slot="singleLabel" slot-scope="{ option }">
                    <el-tag
                      size="medium"
                      :class="[
                        'priority',
                        option.categoryName == 'Hỏa tốc' ? 'lv1' : '',
                        option.categoryName == 'Bình thường' ? 'lv3' : '',
                        option.categoryName == 'Khẩn' ? 'lv2' : ''
                      ]"
                    >
                      {{ option.categoryName }}
                    </el-tag>
                  </template>
                </multiselect>
              </el-form-item>

              <el-form-item class="custom-label__input" prop="deadlineDate">
                <span :class="[this.isXuLyCoHan ? 'field-needed' : '', 'label-input']">Hạn xử lý: </span>
                <el-date-picker
                  class="style-fullWidth input-font__bold input-border__bottom input-border__radius__0"
                  v-model="deadlineDate"
                  type="datetime"
                  :prefix-icon="' '"
                  placeholder="dd/mm/yyyy"
                  default-time="17:30:00"
                  format="dd/MM/yyyy HH:mm"
                ></el-date-picker>
              </el-form-item>

              <el-row :gutter="12">
                <el-col :span="15">
                  <el-form-item
                    class="custom-label__multiple__element"
                    prop="numberOfPage"
                  >
                    <span class="label-input">Số trang: </span>
                    <el-input-number
                      class="style-fullWidth input-font__bold"
                      v-model="form.numberOfPage"
                      placeholder="-"
                      size="mini"
                      :controls="true"
                      :min="0"
                      :step="1"
                      :precision="0"
                      :max="1000"
                    >
                    </el-input-number>
                  </el-form-item>
                </el-col>
                <el-col :span="9">
                  <el-form-item
                    class="custom-label__multiple__element"
                    prop="numberOfCopy"
                  >
                    <span class="label-input width__auto">Số bản: </span>
                    <el-input-number
                      :controls="true"
                      class="style-fullWidth input-font__bold"
                      v-model="form.numberOfCopy"
                      placeholder="-"
                      size="mini"
                      :min="0"
                      :step="1"
                      :precision="0"
                      :max="1000"
                    >
                    </el-input-number>
                  </el-form-item>
                </el-col>
              </el-row>
              <!--văn bản quy phạm pháp luật-->
              <el-form-item
                class="custom-label__input"
                v-if="isBanHanhTrucLienThong"
              >
                <span class="label-input">Văn bản quy phạm pháp luật</span>
                <el-checkbox
                  :border="false"
                  v-model="form.isLawDocument"
                  class="style-fullWidth has-border__bottom"
                ></el-checkbox>
              </el-form-item>
              <!--loại chỉ đạo-->
              <el-form-item
                class="custom-label__input margin-top-10"
                v-if="isBanHanhTrucLienThong"
                prop="steeringTypeId"
              >
                <span :class="['label-input', 'field-needed']"
                >Loại chỉ đạo</span
                >
                <el-select
                  clearable
                  class="style-fullWidth input-font__bold input-border__bottom input-border__radius__0"
                  v-model="form.steeringTypeId"
                  filterable
                  placeholder="-"
                >
                  <el-option
                    v-for="item in steeringTypes"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                  ></el-option>
                </el-select>
              </el-form-item>

              <el-form-item class="custom-label__input" prop="processLevelId">
                <span class="label-input field-needed">Mức độ xử lý: </span>
                <multiselect
                  :class="[
                    form.processLevelId ? '' : '',
                    'style-fullWidth input-font__bold',
                    'input-border__radius__0'
                  ]"
                  :options="processLevels"
                  label="categoryName"
                  track-by="id"
                  :preselect-first="true"
                  v-model="processLevel"
                  placeholder="-"
                  :multiple="false"
                  :close-on-select="true"
                  :clear-on-select="true"
                  :searchable="true"
                  open-direction="top"
                >
                  <template slot="noResult"
                  >Không tìm thấy dữ liệu phù hợp.
                  </template>
                  <template slot="noOptions"
                  >Danh sách trống
                  </template>
                  <template slot="singleLabel" slot-scope="{ option }">
                    <el-tag
                      size="medium"
                      :class="[
                        'processLevel',
                        option.categoryName == 'Nhận để biết' ? 'lv4' : '',
                        option.categoryName == 'Yêu cầu xử lý' ? 'lv3' : '',
                        option.categoryName == 'Xử lý có hạn' ? 'lv2' : ''
                      ]"
                    >
                      {{ option.categoryName }}
                    </el-tag>
                  </template>
                </multiselect>
              </el-form-item>

              <el-form-item v-if="tenantCode !== 'vinatabatrading.com.vn'" class="custom-label__input">
                <span class="label-input">Ban hành văn bản giấy: </span>
                <el-checkbox
                  v-model="isBanHanhBanGiay"
                  disabled
                />
              </el-form-item>

<!--              <el-form-item v-if="tenantCode !== 'vinatabatrading.com.vn'" class="custom-label__input">-->
<!--                <span class="label-input">Không có tài liệu kèm:</span>-->
<!--                <el-checkbox-->
<!--                  v-model="isNotFileDinhKem"-->
<!--                  disabled-->
<!--                />-->
<!--              </el-form-item>-->
              <el-form-item v-if="tenantCode !== 'vinatabatrading.com.vn'" class="custom-label__input">
                <span class="label-input">Không có tài liệu kèm:</span>
                <el-checkbox
                  v-model="isNotFileDinhKem"
                  @change= "confirmKhongCoFileDinhKem"
                  :disabled= "isNotFileDinhKem || roleCode != 'vanthu'"
                />
              </el-form-item>

              <!-- khi vb bị từ chối => hiện thị lý do từ chối -->
              <div v-if="form.status === INCOMING_DOC_STATUS.TU_CHOI">
                <el-form-item class="custom-label__input" prop="commentLog">
                  <span class="label-input">Lý do từ chối: </span>
                  <el-input
                    :value="commentLog"
                    class="style-fullWidth input-font__bold input-border__bottom input-border__radius__0"
                  ></el-input>
                </el-form-item>
              </div>
            </div>
          </div>
        </div>

<!--        <doc-relations-form-->
<!--          v-if="isBanHanhTrucLienThong || (docRelations && docRelations.length > 0)"-->
<!--          :title="'Văn bản liên quan'"-->
<!--          :doc="incomingDoc"-->
<!--          :attachedType="DOC_RELATION_ATTACHED_TYPE.ATTACHED"-->
<!--          :isShowRequiredSignCaCB="false"-->
<!--          ref="attachedDocRelationsForm"-->
<!--        />-->

<!--        v-if= "(docRelationsVBDBHK && docRelationsVBDBHK.length) || (!checkDocRelation && checkVTCreate)"-->

        <doc-relations
          v-if= "(checkVTCreate) || isBanHanhTrucLienThong || (docRelations && docRelations.length > 0)"
          :title="'Văn bản liên quan ban hành kèm'"
          :attachedType="DOC_RELATION_ATTACHED_TYPE.ATTACHED_INCOM"
          :attachedTypeElectronic="DOC_RELATION_ATTACHED_TYPE.ATTACHED"
          :docId="id"
          ref="attachedDocRelationsForm"
        ></doc-relations>

<!--        <div-->
<!--          v-if="docRelations && docRelations.length > 0"-->
<!--          class="group__info margin-top-10 margin-bottom-10 padding-bottom-10"-->
<!--        >-->
<!--          <div class="title font-size__medium">Văn bản liên quan</div>-->
<!--          <div class="ctn">-->
<!--            <template>-->
<!--              <el-table-->
<!--                class="table detailRelatedDocs"-->
<!--                :data="docRelations"-->
<!--                style="max-width: 100%; width: 100%;"-->
<!--                size="mini"-->
<!--              >-->
<!--                <el-table-column label="Trích yếu" show-overflow-tooltip>-->
<!--                  <template slot-scope="scope">-->
<!--                    <div class="docName flex-row flex__left margin-right-10">-->
<!--                      <file-type-image-->
<!--                        :custom-class="''"-->
<!--                        :file-extention="scope.row.fileExtention"-->
<!--                      >-->
<!--                      </file-type-image>-->

<!--                      <a-->
<!--                        class="txt style-fullWidth margin-left-10 color__black"-->
<!--                        :href="-->
<!--                          getTokenDocRelation(scope.row.id)-->
<!--                            | buildAttachmentURL({-->
<!--                              type:-->
<!--                                scope.row.objectTypeRelateTo ===-->
<!--                                DOC_RELATION_OBJECT_TYPE.ATTACHMENT-->
<!--                                  ? DOWNLOAD_OPTION.TYPE.ORIGINAL-->
<!--                                  : DOWNLOAD_OPTION.TYPE.PDF-->
<!--                            })-->
<!--                        "-->
<!--                        v-openInNewTab-->
<!--                      >-->
<!--                        {{ scope.row.quote || "-" }}-->
<!--                      </a>-->
<!--                    </div>-->
<!--                  </template>-->
<!--                </el-table-column>-->
<!--                <el-table-column-->
<!--                  label="Loại văn bản"-->
<!--                  width="100"-->
<!--                  show-overflow-tooltip-->
<!--                >-->
<!--                  <template slot-scope="scope">-->
<!--                    {{ getRelationTypeLabel(scope.row.relationType) || "-" }}-->
<!--                  </template>-->
<!--                </el-table-column>-->

<!--                <el-table-column-->
<!--                  label="Số ký hiệu"-->
<!--                  width="120"-->
<!--                  show-overflow-tooltip-->
<!--                >-->
<!--                  <template slot-scope="scope">-->
<!--                    {{ scope.row.docCode || "-" }}-->
<!--                  </template>-->
<!--                </el-table-column>-->
<!--                <el-table-column-->
<!--                  label="Ngày văn bản"-->
<!--                  width="135"-->
<!--                  show-overflow-tooltip-->
<!--                >-->
<!--                  <template slot-scope="scope">-->
<!--                    {{-->
<!--                      scope.row.docDate-->
<!--                        | dateFormatter({dateFormat: "DD/MM/YYYY"})-->
<!--                    }}-->
<!--                  </template>-->
<!--                </el-table-column>-->
<!--              </el-table>-->
<!--            </template>-->
<!--          </div>-->
<!--        </div>-->

        <div class="group__info margin-top-10 padding-bottom-10">
          <div class="title font-size__medium">
            Quy trình xử lý
          </div>
          <div class="content">
            <div class="form-input">
              <el-form-item class="custom-label__input" prop="flowId">
                <span class="label-input field-needed">Chọn quy trình</span>
                <el-select
                  clearable
                  class="style-fullWidth input-font__bold input-border__bottom input-border__radius__0"
                  v-model="form.flowId"
                  size=""
                  filterable
                  placeholder="-"
                  @change="flowIdChange"
                >
                  <el-option
                    v-for="item in flows"
                    :key="item.id"
                    :label="item.flowName"
                    :value="item.id"
                  >
                  </el-option>
                </el-select>
              </el-form-item>

              <div v-if="selectedNodes && selectedNodes.length">
                <el-form-item class="custom-label__input">
                  <el-table
                    :data="selectedNodes"
                    size="mini"
                    fit
                    style="width: 80%; height: 100%; margin-left: 100px;"
                    stripe
                  >
                    <el-table-column type="index" width="40"></el-table-column>
                    <el-table-column label="Cá nhân/ đơn vị">
                      <template slot-scope="scope">
                        <div
                          class="flex-row flex__left"
                          v-if="scope.row.stepType === STEP.STEP_TYPE.CANHAN"
                        >
                          <div class="avt">
                            <div class="avatar_fake flex-row flex__center">
                              <span>{{
                                  scope.row.userDeptRole.fullName
                                    | buildShortNameFilter
                                }}</span>
                            </div>
                          </div>
                          <div class="info margin-left-10">
                            <p class="people__name">
                              {{ scope.row.userDeptRole.fullName }}
                            </p>
                            <p class="people__position">
                              {{ scope.row.userDeptRole.positionName }} -
                              {{ scope.row.userDeptRole.deptName }}
                            </p>
                          </div>
                        </div>
                        <div class="flex-row flex__left" v-else>
                          <div class="avt"></div>
                          <div class="info margin-left-10">
                            <p class="people__name">
                              {{ scope.row.department.deptName }}
                            </p>
                            <p class="people__position">
                              {{ scope.row.department.identityCode }}
                            </p>
                          </div>
                        </div>
                      </template>
                    </el-table-column>
                    <el-table-column
                      label="Vai trò"
                      width="120"
                      show-overflow-tooltip
                    >
                      <template slot-scope="scope">
                        <p>{{ buildProcessType(scope.row.processType) }}</p>
                      </template>
                    </el-table-column>
                    <el-table-column width="50">
                      <template slot-scope="scope">
                        <div
                          class="clickable icon-zoom btn-unselect"
                          @click="removeSelectedNode(scope.row)"
                        >
                          <i class="el-icon-circle-close font-size__large"></i>
                        </div>
                      </template>
                    </el-table-column>
                  </el-table>
                </el-form-item>
              </div>
              <div
                class="custom-label__input flex-row flex__right"
                v-show="selectedNodes && selectedNodes.length"
              >
                <span class="label-input">
                  <el-button
                    size="mini"
                    class="dialogBtnPrimary"
                    @click="isOpenTransferDialog = true"
                    style="margin-bottom: 10px"
                  >
                    <i class="font-size__small fas fa-pencil-alt"></i>
                    &nbsp;Sửa
                  </el-button>
                </span>
              </div>

              <el-form-item class="custom-label__input" prop="flowNote">
                <span class="label-input">Ý kiến/đề xuất/ghi chú: </span>
                <el-input
                  type="textarea"
                  rows="3"
                  v-model="form.flowNote"
                  class="style-fullWidth input-font__bold input-border__bottom input-border__radius__0"
                ></el-input>
              </el-form-item>
            </div>
          </div>
        </div>
      </el-form>
      <div class="el-dialog__footer">
        <div class="flex-row flex__left form-button__action">
          <el-button
            class="dialogBtnPrimary"
            @click="forwardToNextHandler()"
            :disabled="isProcessing"
            v-if="isViewButtonTuChoi()"
          >
            <el-tooltip content="Chuyển Lãnh đạo" placement="top">
              <span class="flex-row flex__center">
                <i
                  :class="[
                    !isProcessing
                      ? 'font-size__small far fa-arrow-alt-circle-right'
                      : 'el-icon-loading'
                  ]"
                ></i>
                &nbsp;Chuyển LĐ
              </span>
            </el-tooltip>
          </el-button>
          <el-button
            class="dialogBtnPrimary"
            @click="saveDoc()"
            :disabled="isProcessing"
            v-if="isViewButtonTuChoi()"
          >
            <el-tooltip content="Lưu văn bản" placement="top">
              <span class="flex-row flex__center">
                <i
                  :class="[
                    !isProcessing
                      ? 'font-size__small far fa-save'
                      : 'el-icon-loading'
                  ]"
                ></i>
                &nbsp;Lưu
              </span>
            </el-tooltip>
          </el-button>
          <!--          h start cây thư mục-->
          <el-button
            class="detailBtn detailBtnPrimary"
            v-if="incomingDoc"
            @click="linkFolder"
          >
            <i class="fas fa-link"></i>
            Liên Kết Thư Mục
          </el-button>
          <!--          h end cây thư mục-->
          <el-button
            class="detailBtn btn__delete btn-none__border color__white bg__red"
            v-show="isEnableTuChoi"
            @click="tuChoiTiepNhan()"
            v-if="isViewButtonTuChoi()"
          >
            <i class="fas fa-ban font-size__small"></i>&nbsp; Từ chối
          </el-button>

          <el-button
            class="detailBtn btn__delete btn-none__border color__white bg__red"
            @click="delete_()"
            v-if="isEnableDelete && isViewButtonTuChoi()"
          >
            <i class="fas fa-trash font-size__small"></i>&nbsp; Xóa văn bản
          </el-button>
          <el-button
            type="info"
            class="btn__cancel btn-none__border"
            @click="cancel"
          >
            <el-tooltip content="Đóng" placement="top">
              <span class="flex-row flex__center">
                <i class="font-size__small el-icon-circle-close-outline"></i>
                &nbsp;Đóng
              </span>
            </el-tooltip>
          </el-button>
        </div>
      </div>
      <scan-dialog
        :isOpen="isOpenScanDialog"
        :objectType="1"
        v-if="isEnableScanDialog"
        @closeDialog="isOpenScanDialog = false"
        @closed="isEnableScanDialog = false"
        @success="scanSuccess"
      />
      <select-department-dialog
        :isOpen="isOpenSelectDepartmentDialog"
        :publisherId="deptId"
        :receiveDepartmentIds="form.publisherId"
        v-if="isEnableSelectDepartmentDialog"
        @closed="isEnableSelectDepartmentDialog = false"
        @closeDialog="isOpenSelectDepartmentDialog = false"
        @change="publisherDepartmentChange"
      >
      </select-department-dialog>
      <tu-choi-van-thu-dialog
        :isOpen="isOpenTuChoiDialog"
        :vbIncomingDocId="incomingDoc.id"
        v-if="isEnableTuChoiDialog"
        @closeDialog="isOpenTuChoiDialog = false"
        @dialogClosed="isEnableTuChoiDialog = false"
        @success="tuChoiTiepNhanSuccess"
      >
      </tu-choi-van-thu-dialog>

      <cxl-vbden-vanthu-dialog
        :isOpen="isOpenTransferDialog"
        :flowId="flowId"
        :quote="form.quote"
        :note="form.flowNote"
        :selectedHandlers="selectedNodes"
        id="pageContainerDialog"
        v-if="isEnableTransferDialog"
        @closed="isEnableTransferDialog = false"
        @closeDialog="isOpenTransferDialog = false"
        @submit="selectHandler"
      >
      </cxl-vbden-vanthu-dialog>
      <!--   hoang   cây thư mục end-->
      <signature-info-list-dialog
        :isOpen="isOpenSignatureInfo"
        :attachmentId="form.attachmentId"
        v-if="isOpenSignatureInfo"
        @closed="isOpenSignatureInfo=false"
      >
      </signature-info-list-dialog>
      <attach-document-name-dialog
        :isOpen="isOpenAttachDocumentDialog"
        v-if="isEnableAttachDocumentDialog"
        @closeDialog="isOpenAttachDocumentDialog = false"
        @closed="isEnableAttachDocumentDialog = false"
        @success="createAttachDocNameSuccess"
      >

      </attach-document-name-dialog>
      <!--      h start-->
      <!--    hoang  cây thư mục start-->
      <tree-folder-dialog
        :isOpen="isOpenDialogCreate"
        :vbId="id"
        :accessoryType="accessoryType"
        @closeDialog="closeTreeFolderDialog"
        @success="createSuccess"
        v-if="isEnableTreeFolderDialog"
        @closed="isEnableTreeFolderDialog"
      />
      <kyTokenDialogDocIn
        :isOpen="isOpenKyTokenDialog"
        v-if="isEnableKyTokenDialog"
        :docDate="docDate"
        :bookNumber="form.bookNumber"
        :publisherDept="forwardDept"
        :signDate="now"
        :docUrl="getToken(vbAttachment.id)
                          | buildAttachmentURL({
                            type: DOWNLOAD_OPTION.TYPE.ORIGINAL
                          })"
        @closed="isEnableKyTokenDialog = false"
        @closeDialog="handleCloseKyTokenDialog"
        @imageObjects="handleTokenImages"
      ></kyTokenDialogDocIn>
      <!--   hoang   cây thư mục end-->
      <DynamicFieldFormDialog  @closeDialog="isOpenDynamicFieldFormDialog = false"
                               @closed="isOpenDynamicFieldFormDialog = false"
                               :isOpen="isOpenDynamicFieldFormDialog"
                               :isLoading="loadingOpenDynamicFieldFormDialog"
                               @submit="submitDynamicFieldForm"
      />
    </div>
  </div>
</template>
<script>
import signatureInfoListDialog from "../signatureInfo/signatureInfoListDialog";
import categoryViewService from "../../services/categoryViewService";
import docRelationService from "../../services/docRelationService";
import constants from "../../constants";
import h from "../../services/h";
import flowService from "../../services/flowService";
import departmentService from "../../services/departmentService";
import nextStepInfoViewService from "../../services/nextStepInfoViewService";
import dateUtils from "../../dateUtils";
import attachmentService from "../../services/attachmentService";
import bookService from "../../services/bookService";
import docInService from "../../services/docInService";
import docInBookService from "../../services/docInBookService";
import userDeptRoleViewService from "../../services/userDeptRoleViewService";
import buildAttachmentURL from "../../filters/buildAttachmentURL.js";
import vbIncomingProcessService from "../../services/vbIncomingProcessService";
import vbAttachmentTokenMixin from "../../mixins/vbAttachmentTokenMixin";
import uploadFileMixin from "./uploadFileMixin";
import tuChoiVanThuDialog from "./components/tuChoiVanThuDialog";
import dateFormatter from "../../filters/dateFormatter";
import buildShortNameFilter from "../../filters/buildShortNameFilter";
import otherDepartmentService from "../../services/otherDepartmentService";
import Transfer from "./components/TransferNewVanThu";
import vbIncomingDocService from "../../services/vbIncomingDocService";
import handleRequestErrorMixin from "../handleRequestErrorMixin";
import CxlVbdenVanthuDialog from "./components/clx-vbden-vanthu-dialog";
import kyTokenDialogDocIn from "./components/kyTokenDialogDocIn";
import incomingDocService from "../../services/incomingDocService";
import errorMessageFilter from "../../filters/errorMessageFilter";
import ScanDialog from "../doc-out/scan-dialog";
import {EventBus} from "../../event-bus";
import treeFolderDialog from "../setting/quanLyTaiLieu/treeFolderDialog";
import {Loading} from "element-ui";
import AttachDocumentNameDialog from "../doc-out/attach-document-name-dialog";
import vbAttachmentTokenService from "../../services/vbAttachmentTokenService";
import signTokenService from "../../services/signTokenService";
import vbIncomingDocInBookViewService from "../../services/vbIncomingDocInBookViewService"
import actionLogService from "../../services/actionLogService";
import signBcycpTokenService from "../../services/signBcycpTokenService";
import docRelationsForm from "../common/doc-relations-form";
import outgoingDocService from "../../services/outgoingDocService";
import DocRelations from "./doc-relations.vue";
import vShareLibService from "../../services/vShareLibService";
import DynamicFieldFormDialog from "./components/DynamicFieldFormDialog.vue";
import Docxtemplater from 'docxtemplater';
import PizZip from 'pizzip';
import { getBinaryContent } from 'pizzip/utils/index';
export default {
  name: "doc-in-create",
  mixins: [vbAttachmentTokenMixin, uploadFileMixin, handleRequestErrorMixin],
  filters: {buildAttachmentURL, dateFormatter, buildShortNameFilter},
  components: {
    DynamicFieldFormDialog,
    DocRelations,
    AttachDocumentNameDialog,
    treeFolderDialog,
    signatureInfoListDialog,
    ScanDialog,
    CxlVbdenVanthuDialog,
    kyTokenDialogDocIn,
    fileTypeImage: () => import("../job/FileTypeImage"),
    selectDepartmentDialog: () => import("./components/selectDepartmentDialog"),
    Transfer,
    tuChoiVanThuDialog,
    docRelationsForm
  },
  props: ["id", "customRequiredFields", "isConfigLD", "subDocId","checkDocRelation" , "checkSave"],

  data() {
    let publisherValidation = (rule, value, callback) => {
      if (!this.form.publisherId && !this.form.outsidePublisherName && !this.form.insidePublisherName) {
        return callback(new Error("Đơn vị phát hành bắt buộc nhập"));
      }
      return callback();
    };
    let insidePublisherValidation = (rule, value, callback) => {
      if (!this.form.publisherId && !this.form.outsidePublisherName && !this.form.insidePublisherName) {
        return callback(new Error("Nơi ban hành bắt buộc nhập"));
      }
      return callback();
    };
    let handlerValidation = (rule, value, callback) => {
      if (!this.form.handlerId && !this.form.handlerDeptId) {
        return callback(new Error("Trường bắt buộc nhập"));
      }
      return callback();
    };
    let docCodeValidation = (rule, value, callback) => {
      // let docCodeRequired = this.findCustomRequiredField('docCode');
      if (!this.docCodeRequired) return callback();
      if (!this.form.docCode) {
        return callback(new Error("Trường ký hiệu bắt buộc nhập"));
      } else {
        return callback();
      }
    };

    return {
      DOC_RELATION_ATTACHED_TYPE: constants.DOC_RELATION_ATTACHED_TYPE,
      IS_PDF: constants.DOWNLOAD_OPTION.TYPE.PDF,
      IS_DOC: constants.DOWNLOAD_OPTION.TYPE.DOC,
      wordEditSrc: null,
      isOpenAttachDocumentDialog: false,
      isEnableAttachDocumentDialog: false,
      OUTGOING_DOC_STATUS: constants.OUTGOING_DOC_STATUS,
      //EventBus comment from History
      receivedComment: null,
      // h- start cây thư mục
      accessoryType: constants.QUAN_LY_TAI_LIEU.VB_DEN,
      DOC_TYPE: constants.DOC_TYPE,
      isOpenDialogCreate: false,
      isEnableTreeFolderDialog: true,
      vbName: null,
      vbId: null,
      vbType: null,
      vbIncomingDocCopy: null,
      // h-end cây thư mục
      isOpenSignatureInfo: false,
      isOpenScanDialog: false,
      isEnableScanDialog: false,
      insideReceiver: null,
      listInsideReceiver: [],
      docRelationsVBDBHK: [],
      isLoading: false,

      selectedNodes: [],
      defaultFlow: null,
      isOpenTransferDialog: false,
      isEnableTransferDialog: false,

      isOpenKyTokenDialog: false,
      isEnableKyTokenDialog: false,
      isSignedToken: false,
      tokenImages: [],

      docRelationTypes: [],
      DOC_RELATION_OBJECT_TYPE: constants.DOC_RELATION_OBJECT_TYPE,
      docRelations: [],

      INCOMING_DOC_STATUS: constants.INCOMING_DOC_STATUS,
      vbAttachmentsState: {},
      DOCUMENT_FILE: constants.DOCUMENT_FILE,
      DOWNLOAD_OPTION: constants.DOWNLOAD_OPTION,
      STEP: constants.STEP,

      incomingDoc: null,
      priorities: [],
      docTypes: [],
      processLevels: [],
      flows: [],
      nextStep: null,
      departments: [],
      docDate: null,
      deadlineDate: null,
      handlers: [],
      nextStepsCaNhan: [],
      actionLogs: [],
      commentLog: null,
      nextStepsDonVi: [],
      deptForNextStep: [],
      vbAttachment: null,
      books: null,
      handler: [],
      handlerDept: null,
      priority: null,
      processLevel: null,
      docInBook: null,
      isSignBeforeForwardLd: 0,
      isSignBeforeForwardLdBCY: 0,
      forwardDept: null,
      isXuLyCoHan: null,
      incomingDatePickerOptions: {
        disabledDate: null
      },

      form: {
        docCode: null,
        incomingDate: null,
        bookNumber: null,
        subBookNumber: null,
        docTypeName: null,
        attachmentFiles: [],
        quote: null,
        attachmentId: null,
        publisherId: null,
        insidePublisherName: null,
        outsidePublisherName: null,
        docTypeId: null,
        docDate: null,
        deadlineDate: null,
        priorityId: null,
        processLevelId: null,
        numberOfCopy: null,
        numberOfPage: null,
        flowId: null,
        handlerId: null,
        handlerDeptId: null,
        handlerRoleId: null,
        handlerPositionId: null,
        flowNote: null,
        bookId: null,
        isLawDocument: null,
        steeringTypeId: null,
        isThuHoiTatCaOrNot: null,
      },

      oldDocInBook: {
        bookId: null,
        bookNumber: null,
        subBookNumber: null,
        incomingDate: null
      },

      validationRules: {
        docCode: [
          {
            validator: docCodeValidation,
            trigger: "change"
          }
        ],
        docDate: [
          {
            required: true,
            message: "Trường dữ liệu bắt buộc",
            trigger: "change"
          }
        ],
        processLevelId: [
          {
            required: true,
            message: "Trường dữ liệu bắt buộc",
            trigger: "change"
          }
        ],
        bookId: [
          {
            required: true,
            message: "Trường dữ liệu bắt buộc",
            trigger: "change"
          }
        ],
        bookNumber: [
          {
            required: true,
            message: "Trường dữ liệu bắt buộc",
            trigger: "change"
          }
        ],
        incomingDate: [
          {
            required: true,
            message: 'Trường dữ liệu bắt buộc',
            trigger: 'change'
          }
        ],
        publisherId: [{validator: publisherValidation, trigger: "change"}],
        outsidePublisherName: [
          {validator: publisherValidation, trigger: "change"}
        ],
        insidePublisherName: [
          {validator: insidePublisherValidation, trigger: "change"}
        ],

        quote: [
          {
            required: true,
            message: "Trường dữ liệu bắt buộc",
            trigger: "change"
          },
          {max: 2000, message: "Không vượt quá 2000 kí tự", trigger: "change"}
        ],
        //
        // flowId: [
        //   {required: true, message: "Trường bắt buộc chọn", trigger: "change"}
        // ],

        handlerId: [{validator: handlerValidation, trigger: "change"}],
        handlerDeptId: [{validator: handlerValidation, trigger: "change"}]
      },

      isOpenSelectDepartmentDialog: false,
      isEnableSelectDepartmentDialog: false,

      isOpenTuChoiDialog: false,
      isEnableTuChoiDialog: false,

      processHandlerForms: [],
      processHandlerDeptForms: [],
      isProcessing: false,
      steeringTypes: null,

      alphabet: ["A","B","C","D","E","F","G","H","I","J","K","L","M","N","O","P","Q","R","S","T","U","V","W","X","Y","Z"],
      isShowSoPhu: false,
      docCodeRequired:false,
      TENANT_CODE: constants.TENANT_CODE,
      now: new Date(),
      vbShareLibAttchment: null,
      isOpenDynamicFieldFormDialog: false,
      loadingOpenDynamicFieldFormDialog: false
    };
  },

  computed: {
    isBanHanhTrucLienThong() {
      return this.incomingDoc && this.incomingDoc.tltvbAgencyId;
    },

    roleCode() {
      return this.$store.getters.userDeptRole.roleCode;
    },

    docStatus() {
      return this.incomingDoc ? this.incomingDoc.status : null;
    },

    flowId() {
      return this.form.flowId;
    },
    bookId() {
      return this.form.bookId;
    },
    uploadAttachmentAdditionalData() {
      return {
        objectType: constants.ATTACHMENT_OBJECT_TYPE.VB_DEN,
        note: ""
      };
    },
    isVanThu() {
      return (
        this.userDeptRole &&
        this.userDeptRole.roleCode === constants.ROLE.CODE.VAN_THU
      );
    },
    userDeptRole() {
      return this.$store.getters.userDeptRole;
    },
    deptId() {
      return this.$store.getters.userDeptRole.deptId;
    },
    userDeptRoleId() {
      return this.$route.params.userDeptRoleId;
    },
    parentRoute() {
      return this.$route.path.split("/")[3];
    },
    isEnableTuChoi() {
      return (
        this.incomingDoc &&
        (this.incomingDoc.forwardIncomingDocId ||
          this.incomingDoc.vbOutgoingDocId ||
          (this.incomingDoc.documentId &&
            !this.incomingDoc.forwardIncomingDocId))
      );
    },
    isEnableDelete() {
      //văn thư được phép xóa văn bản ký ngoài
      return (
        this.isVanThu &&
        this.incomingDoc &&
        this.deptId === this.incomingDoc.toDeptId &&
        !this.incomingDoc.vbOutgoingDocId &&
        !this.incomingDoc.forwardIncomingDocId &&
        !(this.incomingDoc.documentId && !this.incomingDoc.forwardIncomingDocId)
      );
    },

    isBanHanhBanGiay() {
      return this.incomingDoc && !!this.incomingDoc.isBanHanhBanGiay;
    },

    isNotFileDinhKem() {
      return this.incomingDoc && !!this.incomingDoc.isNotFileDinhKem;
    },

    isDaBanHanh() {
      return constants.INCOMING_DOC_STATUS.DANG_XU_LY == this.outgoingDoc.status;
    },


    isFormIncomingDateEqualCurrentDate() {
      let flag = false;
      const formIncomingDate = new Date(new Date(this.form.incomingDate).toDateString()).getTime();
      const currentDate = new Date(new Date().toDateString()).getTime();
      if (formIncomingDate === currentDate) {
        flag = true;
      }
      return flag;
    },

    tenantCode() {
      return this.$store.getters.userDeptRole.tenantCode;
    }
  },

  watch: {
    isOpenTransferDialog(newValue) {
      newValue && (this.isEnableTransferDialog = newValue);
    },

    isOpenKyTokenDialog(newValue) {
      newValue && (this.isEnableKyTokenDialog = newValue);
    },

    isOpenAttachDocumentDialog: function (newValue) {
      newValue && (this.isEnableAttachDocumentDialog = newValue);
    },
    isOpenScanDialog: function (newValue) {
      newValue && (this.isEnableScanDialog = newValue);
    },


    id(newValue) {
      if (newValue) {
        this.loadDocDetail()
          .then(() => this.loadDocInBook())
          .then(() => this.loadBooks())
          .then(() => this.prepareFormForEditMode());
      } else {
        this.loadBooks();
      }
    },

    handler(newValue) {
      if (!newValue && !newValue.length) {
        this.$refs.form && this.$refs.form.clearValidate("handlerId");
      }
      // this.form.handlerId = handlers[0] ? handlers[0].userView.userId : null;
      // let handlers = newValue;
      let handlers = [];
      newValue &&
      newValue.forEach(id => {
        handlers.push(
          h.find(
            this.handlers,
            (item, index) => newValue && item.id.indexOf(id) !== -1
          )
        );
      });
      this.form.handlerId = handlers[0] ? handlers[0].userView.userId : null;

      // this.$refs.form && this.$refs.form.validateField("handlerId");

      this.processHandlerForms = [];
      h.each(handlers, handler => {
        this.processHandlerForms.push({
          userId: handler.userView.userId,
          deptId: handler.userView.deptId,
          roleId: handler.userView.roleId,
          positionId: handler.userView.positionId,
          processType: constants.PROCESS_TYPE.CHUTRI,
          stepId: handler.stepId,
          delegateInfoId: handler.userView.delegateInfoId
        });
      });
    },

    handlerDept(newValue) {
      if (!newValue) return;
      let handlerDepts = newValue;
      this.form.handlerDeptId = newValue[0] ? newValue[0].id : null;

      this.processHandlerDeptForms = [];
      h.each(handlerDepts, handlerDept => {
        this.processHandlerDeptForms.push({
          deptId: handlerDept.id,
          stepId: handlerDept.stepId
        });
      });
    },

    docDate(value) {
      this.form.docDate = value ? value.getTime() : null;
    },

    deadlineDate(value) {
      this.form.deadlineDate = value ? value.getTime() : null;
    },
    priority(newValue) {
      this.form.priorityId = newValue ? newValue.id : null;
    },
    processLevel(newValue) {
      this.form.processLevelId = newValue ? newValue.id : null;
      if (this.form.processLevelId === constants.PROCESS_LEVEL.XU_LY_CO_HAN) {
        this.$refs.form.validateField('deadlineDate');
        this.isXuLyCoHan = true;
      } else {
        this.isXuLyCoHan = false;
        this.$refs.form.clearValidate('deadlineDate');
      }
    },
    isOpenSelectDepartmentDialog(newValue) {
      newValue && (this.isEnableSelectDepartmentDialog = newValue);
    },
    isOpenTuChoiDialog(newValue) {
      newValue && (this.isEnableTuChoiDialog = newValue);
    },

    isXuLyCoHan(newValue) {
      if (newValue) {
        this.validationRules.deadlineDate = [
          {
            required: true,
            message: "Trường dữ liệu bắt buộc",
            trigger: "change"
          }
        ]
      } else {
        this.validationRules.deadlineDate = []
      }
    }
  },

  async created() {
    this.loadDocRelations();
    this.loadCategories();
    this.loadFlows().then(() => this.loadIsSignBeforeForwardLd())
    this.loadDepartments();
    this.initSteeringTypes();
    if (this.id) {
      await this.loadDocDetail()
        .then(() => this.loadDocInBook())
        .then(() => this.loadBooks())
        .then(() => {
          this.prepareFormForEditMode();
          this.saveOldDocInBookValue()
        })
    } else {
      await this.loadBooks();
    }

    this.initDefaultValue();
    this.loadActionLogs();
    this.docCodeRequired = this.findCustomRequiredField('docCode');
    EventBus.$on('commentSent', (data) => {
      this.receivedComment = data;
    });
  },

  destroyed() {
    EventBus.$off('commentSent', this.receivedComment);
  },

  methods: {
    isViewButtonTuChoi(){
      let userId = this.$store.getters.user.id;
      if (this.incomingDoc && this.incomingDoc.status === constants.INCOMING_DOC_STATUS.TU_CHOI) {
        if (this.incomingDoc.vbOutgoingDocId === null){
          if (userId === this.incomingDoc.creatorId){
            return true;
          }else{
            return false;
          }
        }else{
          outgoingDocService
            .findById(this.incomingDoc.vbOutgoingDocId)
            .then(res => {
              let data = res.data;
              if (userId === data.creatorId){
                return true;
              }else{
                return false;
              }
            });
          }
        return false;
        } else {
        return true;
      }
      },

    confirmKhongCoFileDinhKem() {
      this.$confirm('Xác nhận không có tài liệu kèm?', 'Thông báo', {
        confirmButtonText: 'Xác nhận',
        cancelButtonText: 'Hủy',
        type: 'warning'
      }).then(() =>
        incomingDocService.setKhongCoFileDinhKem(this.id)
          .then(() => {
            this.$message({
              type: 'success',
              message: 'Xác nhận không có tài liệu kèm thành công!'
            })
            this.incomingDoc.isNotFileDinhKem = 1;
            EventBus.$emit(this.parentRoute, {});
          })
          .catch(() => {
            console.log('Lỗi set ban hành văn bản.')
          })
      ).catch(() => {

      });
    },

    // Lưu lại giá trị ban đầu của bookId, bookNumber, subBookNumber, incomingDate
    saveOldDocInBookValue() {
      this.oldDocInBook.bookId = this.form.bookId;
      this.oldDocInBook.bookNumber = this.form.bookNumber;
      this.oldDocInBook.subBookNumber = this.form.subBookNumber;
      this.oldDocInBook.incomingDate = new Date(new Date(this.form.incomingDate).toDateString());
    },

    handleCloseKyTokenDialog() {
      this.isProcessing = false;
      this.isOpenKyTokenDialog = false;
    },

    initDefaultValue() {
      this.form.incomingDate = this.form.incomingDate ? this.form.incomingDate : new Date();
      // this.deadlineDate = this.deadlineDate ? this.deadlineDate : new Date(
      //   new Date().getTime() + 7 * 24 * 60 * 60 * 1000
      // );
      this.form.numberOfCopy = 1;
      this.incomingDatePickerOptions.disabledDate = time => new Date().getTime() < time.getTime();
    },

    handleTokenImages(tokenImages) {
      this.isSignedToken = true;
      this.isOpenKyTokenDialog = false;
      this.tokenImages = tokenImages;
      this.forwardToNextHandler();
    },

    createAttachDocNameSuccess(data) {

      this.isOpenAttachDocumentDialog = false;
      this.isEnableAttachDocumentDialog = false;
      attachmentService.createTemplateFile({
        fileName: data.name,
        fileType: "fileType",
        fileExtension: "docx"
      }).then((response) => {
        this.uploadAttachmentSuccess(response.data);
        let loadingInstance = Loading.service({});
        setTimeout(function () {
          loadingInstance.close();
        }, 1000)
      });
    },
    openCreateTemplateFile() {
      this.isOpenAttachDocumentDialog = true
      this.isCreateTemplateFile = true
    },
    linkFolder() {
      this.isEnableCreateDialog = true;
      this.isOpenDialogCreate = true
      this.isEnableTreeFolderDialog = true
    },
    createSuccess() {
      this.isOpenDialogCreate = false;
    },
    closeTreeFolderDialog() {
      this.isEnableTreeFolderDialog = false
    },
    showSignatureInfo() {
      console.log('showSignature info id', this.incomingDoc)
      this.isOpenSignatureInfo = true
    },
    scanSuccess(data) {
      this.isOpenScanDialog = false;
      this.isEnableScanDialog = false;
      this.vbAttachment = data.attachment;
      this.form.attachmentId = data.attachment.id;
      this.form.numberOfPage = data.attachment.pageNumber;

    },
    initSteeringTypes() {
      this.steeringTypes = [
        {
          id: constants.STEERING_TYPE.KHONGPHAICHIDAO,
          name: errorMessageFilter({
            errorCode: "steeringType.label.khongphaichidao"
          })
        },
        {
          id: constants.STEERING_TYPE.CHIDAO,
          name: errorMessageFilter({
            errorCode: "steeringType.label.chidao"
          })
        },
        {
          id: constants.STEERING_TYPE.BAOCAOCHIDAO,
          name: errorMessageFilter({
            errorCode: "steeringType.label.baocaochidao"
          })
        }
      ];
    },

    remoteMethod(query) {
      if (query !== "") {
        this.findOtherDept(query);
      } else {
        this.options = [];
      }
    },

    findOtherDept(query) {
      this.isLoading = true;
      otherDepartmentService
        .search(query, this.deptId, {sort: "count,desc", page: 0, size: 20})
        .then(res => {
          this.listInsideReceiver = res.data;
          this.isLoading = false;
        });
    },

    removeSelectedNode(row) {
      this.selectedNodes.splice(this.selectedNodes.indexOf(row), 1);
    },

    buildProcessType(processType) {
      switch (processType) {
        case constants.PROCESS_TYPE.CHUTRI:
          return "Chủ trì";
        case constants.PROCESS_TYPE.PHOIHOP:
          return "Phối hợp";
        case constants.PROCESS_TYPE.NHANDEBIET:
          return "Nhận để biết";
        default:
          return "Chủ trì";
      }
    },
    delete_() {
      this.$confirm(
        `Bạn có muốn xóa văn bản "${this.incomingDoc.quote}" ?`,
        "Thông báo",
        {
          confirmButtonText: "Xác nhận",
          cancelButtonText: "Hủy bỏ",
          type: "warning"
        }
      ).then(() => {
        incomingDocService
          .deleteForVanThu(this.id)
          .then(() => {
            this.$message({
              message: "Xóa thành công",
              type: "success",
              duration: 2000
            });
            EventBus.$emit('loadCounting', '');
            this.backModel();
            this.$emit("deleteSuccess");
          })
          .catch(error => this.commonHandleRequestError(error));
      });
    },
    selectHandler(event) {
      this.isOpenTransferDialog = false;
      this.selectedNodes = event.handlersData;
      this.form.flowNote = event.note;
    },

    getRelationTypeLabel(relationType) {
      let docRelationType = h.find(
        this.docRelationTypes,
        docRelationType => docRelationType.id === relationType
      );
      return docRelationType ? docRelationType.categoryName : null;
    },

    backModel() {
      const namePageBack = this.$route.path.split("/");
      this.$router.push({name: `${namePageBack[3]}`});
    },

    tuChoiTiepNhanSuccess() {
      this.isOpenTuChoiDialog = false;
      this.message(
        "Thông báo",
        "Từ chối tiếp nhận văn bản thành công",
        "success",
        3000
      );
      this.backModel();
      this.$emit("rejectSuccess");
    },

    tuChoiTiepNhan() {
      this.isOpenTuChoiDialog = true;
    },

    clearValidate() {
      this.$refs.form.clearValidate("publisherId");
    },

    markAsRead() {
      if (this.incomingDoc && this.incomingDoc.forwardIncomingProcessId) {
        vbIncomingProcessService
          .markAsRead(this.incomingDoc.forwardIncomingProcessId)
          .then(() => null)
          .catch(error => this.commonHandleRequestError(error));
      }
    },
    publisherDepartmentChange(event) {
      let department = event.selectedDepartment;
      this.form.publisherId = department ? department.id : null;
      this.isOpenSelectDepartmentDialog = false;
      this.$refs.form && this.$refs.form.validateField("publisherId");
      this.$refs.form.clearValidate(["insidePublisherName"]);
      this.form.outsidePublisherName = "";
      this.form.insidePublisherName = "";
    },

    publisherIdChange() {
      this.$refs.form && this.$refs.form.validateField("publisherId");
      this.$refs.form.clearValidate(["insidePublisherName"]);
      this.form.outsidePublisherName = "";
      this.form.insidePublisherName = "";
    },
    insidePublisherChange(){
      this.$refs.form && this.$refs.form.clearValidate(['publisherId']);
      this.form.publisherId = "";
      this.form.outsidePublisherName = "";
    },

    outsidePublisherChange() {
      this.$refs.form && this.$refs.form.validateField("publisherId");
      this.$refs.form.clearValidate(["insidePublisherName"]);
      this.form.publisherId = "";
      this.form.insidePublisherName = "";
    },

    resetForm() {
      // this.uploadAttachment = null;
      // this.vbAttachment = null;
      // this.flows = [];
      this.nextStepsCaNhan = null;
      this.id = null;
      this.deadlineDate = null;
      this.docDate = null;
      this.handler = [];
      this.priority = null;
      this.processLevel = null;
      // this.incomingDate = null;
      // this.handlers = [];
      this.form = {
        docCode: null,
        incomingDate: null,
        bookNumber: null,
        subBookNumber: null,
        docTypeName: null,
        attachmentFiles: [],
        quote: null,
        attachmentId: null,
        publisherId: null,
        docTypeId: null,
        docDate: null,
        deadlineDate: null,
        priorityId: null,
        processLevelId: null,
        numberOfCopy: null,
        numberOfPage: null,
        flowId: null,
        handlerId: null,
        handlerDeptId: null,
        handlerRoleId: null,
        flowNote: null,
        bookId: null
      };

      let book = h.find(this.books, item => item.id == this.form.bookId);
      book && (book.bookCurrentNumber += 1);
    },

    cancel() {
      this.$emit("cancel");
    },

    flowIdChange() {
      this.$refs.form && this.$refs.form.validateField("flowId");
      this.handler = [];
      // this.loadNextStep();
      this.isOpenTransferDialog = true;
      this.selectedNodes = []
      this.loadIsSignBeforeForwardLd();
    },

    docInBookInfoChanged() {
      // Trong qua trình thay đổi, nếu giữ nguyên giá trị sổ đến và ngày đến thì sẽ giữ nguyên giá trị của số đến và số phụ như lúc load ban đầu
      this.isShowSoPhu = false;
      const formIncomingDate = new Date(new Date(this.form.incomingDate).toDateString());
      if (this.oldDocInBook.bookId === this.form.bookId && this.oldDocInBook.incomingDate.getTime() === formIncomingDate.getTime()) {
        this.form.bookNumber = this.oldDocInBook.bookNumber;
        this.form.subBookNumber = this.oldDocInBook.subBookNumber;
      } else {
        this.generateNextBookNumber();
      }
    },

    docInBookInfoChangedForBookNumberWhenTuChoi() {
      // giống hàm ở trên nhưng đối với vb đã bị từ chối thì vẫn gen ra số đến, ko giữ số cũ
      if (this.form.status !== constants.INCOMING_DOC_STATUS.TU_CHOI){
        this.isShowSoPhu = false;
        const formIncomingDate = new Date(new Date(this.form.incomingDate).toDateString());
        if (this.oldDocInBook.bookId === this.form.bookId && this.oldDocInBook.incomingDate.getTime() === formIncomingDate.getTime()) {
          this.form.bookNumber = this.oldDocInBook.bookNumber;
          this.form.subBookNumber = this.oldDocInBook.subBookNumber;
        } else {
          this.generateNextBookNumber();
        }
      }else{
        this.generateNextBookNumber();
      }
    },

    async generateNextBookNumber() {
      let formBookNumber = 0;

      let bookCurrentNumber;
      await bookService.findById(this.form.bookId).then(response => {
        bookCurrentNumber = response.data.bookCurrentNumber;
      });
      formBookNumber = bookCurrentNumber + 1;

      // remove time part
      const formIncomingDate = new Date(new Date(this.form.incomingDate).toDateString());
      const currentDate = new Date(new Date().toDateString());

      // Lấy ra thông tin VbDocInBook với bookNumver lớn nhất và subBookNumber lớn nhất theo bookId và incomingDate
      let maxVbDocInBook = null;
      await vbIncomingDocInBookViewService.findFirstByVbDocInBookBookIdAndLessThanIncomingDate(this.form.bookId, formIncomingDate.getTime())
      .then(response => maxVbDocInBook = response.data)
      // bookNumver lớn nhất theo bookId và incomingDate
      let maxBookNumberByBookIdAndIncomingDate = maxVbDocInBook !== '' ? maxVbDocInBook.bookNumber : 0;

      // Lấy ra subBookNumber lớn nhất theo bookId và bookNumber
      let maxSubBookNumberByBookNumber = "";
      await vbIncomingDocInBookViewService.findMaxSubBookNumberByBookIdAndBookNumber(this.form.bookId, maxBookNumberByBookIdAndIncomingDate)
        .then(response => maxSubBookNumberByBookNumber = response.data)

      if(formIncomingDate.getTime() < currentDate.getTime() && bookCurrentNumber > maxBookNumberByBookIdAndIncomingDate) {
        this.isShowSoPhu = true;
        if(maxVbDocInBook !== '') {
          formBookNumber = maxVbDocInBook.bookNumber;
          if (maxSubBookNumberByBookNumber) {
            const nextIndex = this.alphabet.indexOf(maxSubBookNumberByBookNumber) + 1;
            this.form.subBookNumber = this.alphabet[nextIndex];
          } else {
            this.form.subBookNumber = this.alphabet[0];
          }
        }
        // Nếu chọn ngày đến trong quá khứ và trước đó chưa có số văn bản nào thì mặc định chọn bookNumber la 1
        else {
          formBookNumber = 1;
          await vbIncomingDocInBookViewService.findMaxSubBookNumberByBookIdAndBookNumber(this.form.bookId, formBookNumber)
            .then(response => maxSubBookNumberByBookNumber = response.data)
          if (maxSubBookNumberByBookNumber) {
            const nextIndex = this.alphabet.indexOf(maxSubBookNumberByBookNumber) + 1;
            this.form.subBookNumber = this.alphabet[nextIndex];
          } else {
            this.form.subBookNumber = this.alphabet[0];
          }
        }
      } else {
        this.form.subBookNumber = null;
      }
      this.form.bookNumber = formBookNumber;
    },

    loadBooks() {
      return bookService
        .getAllBook(
          {
            bookType: constants.BOOK_TYPE.VB_DEN,
            includeIds: this.id ? [this.docInBook.bookId] : null,
            vbBookStatus: constants.VB_BOOK.STATUS.ACTIVE
          },
          {sort: "bookName,asc", page: 0}
        )
        .then(response => (this.books = response.data));
    },

    removeUploadAttachment() {
      this.wordEditSrc = null;
      this.vbAttachment = null;
      this.form.attachmentId = null;
      this.form.attachmentFiles = [];
    },

    saveDoc() {
      this.$refs.form.validateField("bookId");
      this.$refs.form.validate(valid => {
        if (!valid) {
          this.notify("Lỗi", "Có lỗi nhập liệu !", "error", 2000);
        } else {
          let submitForm = this.convertToSubmitForm(1);
          this.isProcessing = true;
          docInService
            .createIncomingDoc(submitForm)
            .then(response => {
              this.isProcessing = false;

              this.$message({
                message: 'Lưu văn bản thành công!',
                type: 'success'
              });

              for (const messageItem of response.data.message) {
                this.$message({
                    message: errorMessageFilter({errorCode: messageItem.messageCode, params: messageItem.params}),
                    type: 'warning'
                });
              }

              this.$emit("success");
              EventBus.$emit('loadCounting', '');

            })
            .catch(error => {
              this.isProcessing = false;
              return this.commonHandleRequestError(error);
            });
        }
      });
    },

    checkDocCodeDuplicated() {
      let docCode = this.form.docCode;
      docCode && (docCode = docCode.trim());
      if (!docCode) return Promise.resolve(true);
      return vbIncomingDocService
        .findAllByDocCodeAndToDeptId(docCode, this.id)
        .then(response => {
          let vbIncomingDocs = response.data;
          if (!vbIncomingDocs || !vbIncomingDocs.length) return true;
          this.isProcessing = false;
          return this.$confirm(
            `Đã tồn tại văn bản với số ký hiệu [${docCode}]. Bạn vẫn muốn tiếp tục tiếp nhận văn bản này ?`,
            "Thông báo",
            {
              confirmButtonText: "Xác nhận",
              cancelButtonText: "Hủy bỏ",
              type: "warning"
            }
          ).then(() => true);
        });
    },

    forwardToNextHandler() {
      if (!this.flowId) {
        this.notify("Lỗi", "Chưa chọn luồng xử lý !", "error", 2000);
      } else if (this.selectedNodes.length == 0) {
        this.isOpenTransferDialog = true;
      } else {
        this.$refs.form.validateField("bookId");
        this.$refs.form.validate(valid => {
          if (!valid) {
            this.notify("Lỗi", "Có lỗi nhập liệu !", "error", 2000);
          } else {
            this.isProcessing = true;
            this.checkDocCodeDuplicated()
              .then(isContinue => {
                if (!isContinue) return;
                let promise = new Promise(resolve => resolve(true));
                if (this.isSignBeforeForwardLd === 1) {
                  if(this.isSignedToken === false){
                    this.isOpenKyTokenDialog = true;
                    return;
                  }
                  if (this.tokenImages !== null && this.tokenImages.length !== 0) {
                    promise = this.signVbAttachment(this.tokenImages);
                  } else {
                    promise = this.signVbWithoutTokenImages();
                  }
                }
                if (this.isSignBeforeForwardLdBCY === 1) {
                  promise = this.signVbAttachmentBCY();
                }
                promise.then(() => {
                  let submitForm = this.convertToSubmitForm(0);
                  let processHandlerForms = this.selectedNodes
                    .filter(
                      item => item.stepType === constants.STEP.STEP_TYPE.CANHAN
                    )
                    .map(item => {
                      let userDeptRole = item.userDeptRole;
                      return {
                        userId: userDeptRole.userId,
                        deptId: userDeptRole.deptId,
                        roleId: userDeptRole.roleId,
                        positionId: userDeptRole.positionId,
                        userDeptRoleId: userDeptRole.id,
                        processType: item.processType,
                        stepId: item.stepId
                      };
                    });

                  let processHandlerDeptForms = this.selectedNodes
                    .filter(
                      item => item.stepType === constants.STEP.STEP_TYPE.DONVI
                    )
                    .map(item => {
                      return {
                        deptId: item.department.id,
                        stepId: item.stepId,
                        processType: item.processType
                      };
                    });

                  submitForm.flowId = this.form.flowId;
                  submitForm.note = this.form.flowNote;
                  submitForm.processHandlerForms = processHandlerForms;
                  submitForm.processHandlerDeptForms = processHandlerDeptForms;

                  docInService
                    .createIncomingDoc(submitForm)
                    .then(response => {
                      this.isProcessing = false;

                      this.$message({
                        message: 'Chuyển xử lý lãnh đạo thành công!',
                        type: 'success'
                      });

                      for (const messageItem of response.data.message) {
                        this.$message({
                          message: errorMessageFilter({errorCode: messageItem.messageCode, params: messageItem.params}),
                          type: 'warning'
                        });
                      }

                      EventBus.$emit('loadCounting', '');
                      this.$emit("cxlSuccess");
                    })
                    .catch(error => {
                      this.isProcessing = false;
                      return this.commonHandleRequestError(error);
                    });
                })
                .catch((err) => {
                  this.isProcessing = false
                  this.notify(
                    "Lỗi",
                    errorMessageFilter({
                      errorCode: "tokenCA.signPdfError",
                      params: [err]
                    }),
                    "error",
                    4000
                  );
                });
              })
          }
        });
      }
    },

    loadDocDetail() {
      return docInService
        .findById(this.id)
        .then(response => (this.incomingDoc = response.data));
    },

    loadDocInBook() {
      return docInBookService
        .findByDocId(this.id)
        .then(response => (this.docInBook = response.data));
    },

    prepareFormForEditMode() {
      this.form.docCode = this.incomingDoc.docCode;
      this.form.incomingDate = this.incomingDoc.incomingDate;
      this.form.docTypeId = this.incomingDoc.docTypeId;
      this.form.publisherId = this.incomingDoc.publisherId;
      this.form.priorityId = this.incomingDoc.priorityId;
      this.form.processLevelId = this.incomingDoc.processLevelId;
      // this.form.securityId = this.incomingDoc.securityId;
      this.form.numberOfPage = this.incomingDoc.numberOfPage;
      this.form.numberOfCopy = this.incomingDoc.numberOfCopy;
      this.form.quote = this.incomingDoc.quote;
      this.form.quote = this.incomingDoc.quote;
      this.form.insidePublisherName = this.incomingDoc.insidePublisherName;
      this.form.outsidePublisherName = this.incomingDoc.outsidePublisherName;
      this.form.status = this.incomingDoc.status;
      this.form.isLawDocument =
        this.incomingDoc.isLawDocument === constants.TRUE;
      this.form.steeringTypeId = this.incomingDoc.steeringType;
      this.form.isThuHoiTatCaOrNot = this.incomingDoc.isThuHoiTatCaOrNot;
      this.docDate = this.incomingDoc.docDate
        ? dateUtils.toMoment(this.incomingDoc.docDate).toDate()
        : null;
      this.deadlineDate = this.incomingDoc.deadlineDate
        ? dateUtils.toMoment(this.incomingDoc.deadlineDate).toDate()
        : this.deadlineDate;

      attachmentService
        .findAll({
          objectId: this.id,
          objectType: constants.ATTACHMENT_OBJECT_TYPE.VB_DEN
        })
        .then(response => {
          if (response.data && response.data.length) {
            this.vbAttachment = response.data[0];
            this.form.attachmentId = this.vbAttachment.id;
          }
        }).then(() => {
        if (this.id) {
          this.wordEditSrc = constants.EDIT_ONLINE_SERVICE_URL + "editWord" + "?tenantCode=" + this.$store.getters.user.tenantCode + "&attachmentId=" + this.vbAttachment.id;
        } else {
          this.wordEditSrc = constants.EDIT_ONLINE_SERVICE_URL + "autoEditWord" + "?tenantCode=" + this.$store.getters.user.tenantCode + "&attachmentId=" + this.vbAttachment.id;
        }
      });

      if (this.docInBook) {
        this.form.bookId = this.docInBook.bookId;
        this.form.bookNumber = this.docInBook.bookNumber;
        this.form.subBookNumber = this.docInBook.subBookNumber;
      }

      //load vb liên quan
      docRelationService
        .findAll({
          objectId: this.id,
          objectType: constants.DOC_RELATION_OBJECT_TYPE.VB_DEN
        })
        .then(response => {
          this.docRelations = response.data;
          // this.docRelations.push(...response.data);
        });

      // //load vb liên quan attachedType = 0
      // docRelationService
      //   .findAll({
      //     objectId: this.id,
      //     attachedType: constants.DOC_RELATION_ATTACHED_TYPE.ATTACHED
      //   })
      //   .then(response => {
      //     this.docRelations = response.data;
      //     // this.docRelations.push(...response.data);
      //   });

      /**
       * load thông tin priority;
       */
      this.incomingDoc.priorityId &&
      categoryViewService
        .findById(this.incomingDoc.priorityId)
        .then(response => (this.priority = response.data));

      /**
       * load thông tin processLevel;
       */
      this.incomingDoc.processLevelId &&
      categoryViewService
        .findById(this.incomingDoc.processLevelId)
        .then(response => (this.processLevel = response.data));

      this.markAsRead();
    },

    convertToSubmitForm(isSaveDoc) {
      let relationDocs = [];
      console.log('check : ', !this.checkDocRelation || this.checkSave)

        relationDocs.push(
          ...(this.$refs.attachedDocRelationsForm.getRelationDocs() || [])
        );
      let submitForm = {
        id: this.id,
        docCode: this.form.docCode,
        docTypeId: this.form.docTypeId,
        docDate: this.form.docDate,
        publisherId: this.form.publisherId,
        insidePublisherName: this.form.insidePublisherName,
        outsidePublisherName: this.form.outsidePublisherName,
        priorityId: this.priority ? this.priority.id : null,
        processLevelId: this.processLevel ? this.processLevel.id : null,
        // securityId: this.form.securityId,
        deadlineDate: this.form.deadlineDate,
        numberOfPage: this.form.numberOfPage,
        numberOfCopy: this.form.numberOfCopy,
        quote: this.form.quote,
        relationDoc: relationDocs,
        isSaveDoc: isSaveDoc,
        incomingDate: this.form.incomingDate ? new Date(this.form.incomingDate).getTime() : null,

        docInBook: {
          bookId: this.form.bookId,
          bookNumber: this.form.bookNumber,
          subBookNumber: this.form.subBookNumber
        },

        note: this.form.note,
        attachId: this.form.attachmentId,
        deptId: this.deptId,
        isLawDocument: this.form.isLawDocument
          ? constants.TRUE
          : constants.FALSE,
        steeringTypeId: this.form.steeringTypeId,
      };

      if (this.tenantCode === constants.TENANT_CODE.VINATABA) {
        if (this.incomingDoc && this.incomingDoc.tltvbAgencyId) {
          let docRelations = [];
          if (this.$refs.attachedDocRelationsForm) {
            docRelations.push(
              ...(this.$refs.attachedDocRelationsForm.getRelationDocs() || [])
            );
          }
          submitForm.docRelation = docRelations;
        }
      }

      return submitForm;
    },

    loadDocRelations() {
      docRelationService
        .findAllByAttachedType({
          objectId: this.id,
          attachedType: constants.DOC_RELATION_ATTACHED_TYPE.ATTACHED_INCOM
        })
        .then(response => {
          this.docRelationsVBDBHK = response.data;
        });
    },

    checkVTCreate() {
      return this.incomingDoc.creatorId === this.userDeptRole.userId
        && this.userDeptRole.roleCode === constants.ROLE.CODE.VAN_THU;
    },

    receiverLabel(usersView) {
      return `${usersView.fullName} (${usersView.positionName} - ${
        usersView.deptName
      })`;
    },
    /**
     * filter lại danh sách đơn vị phát hành bên trong, chi cho phép ban hành trong đơn vị cha hoặc đơn vị ngang cấp
     * của đơn vị ban hành văn bản;
     */
    loadDepartments() {
      departmentService.findAll().then(response => {
        let departments = h.findAll(
          response.data,
          item =>
            item.status === constants.DEPARTMENT.STATUS.ACTIVE ||
            item.id === this.form.publisherId
        );
        this.departments = departmentService.prepareReceiveDepartments(
          this.deptId,
          departments
        );

      });
      // let departments;
      // departmentService.findAllForTenant().then(response => {
      //   departments=response.data;
      //   this.departments=response.data
      //   // departments= h.findAll(
      //   //   response.data,
      //   //   item =>
      //   //     item.status === constants.DEPARTMENT.STATUS.ACTIVE ||
      //   //     item.id === this.form.publisherId
      //   // );
      //
      //   if (this.id) {
      //     this.wordEditSrc = constants.EDIT_ONLINE_SERVICE_URL + "editWord" + "?tenantCode=" + this.$store.getters.user.tenantCode + "&attachmentId=" + this.vbAttachment.id;
      //   } else {
      //     this.wordEditSrc = constants.EDIT_ONLINE_SERVICE_URL + "autoEditWord" + "?tenantCode=" + this.$store.getters.user.tenantCode + "&attachmentId=" + this.vbAttachment.id;
      //   }
      //
      // }).then(()=>{
      //   // console.log("departments",departments)
      //   // this.departments = departmentService.prepareReceiveDepartments(
      //   //   this.deptId,
      //   //   departments
      //   // );
      //   }
      //
      // );
    },

    uploadAttachmentSuccess(vbAttachment) {
      this.vbAttachment = vbAttachment;
      this.form.attachmentId = vbAttachment.id;
      this.form.numberOfPage = vbAttachment.pageNumber;
      this.form.numberOfCopy = 1;
      if (this.id) {
        this.wordEditSrc = constants.EDIT_ONLINE_SERVICE_URL + "editWord" + "?tenantCode=" + this.$store.getters.user.tenantCode + "&attachmentId=" + this.vbAttachment.id;
      } else {
        if (this.isCreateTemplateFile) {
          this.wordEditSrc = constants.EDIT_ONLINE_SERVICE_URL + "autoEditWord" + "?tenantCode=" + this.$store.getters.user.tenantCode + "&attachmentId=" + this.vbAttachment.id;
        } else {
          this.wordEditSrc = constants.EDIT_ONLINE_SERVICE_URL + "editWord" + "?tenantCode=" + this.$store.getters.user.tenantCode + "&attachmentId=" + this.vbAttachment.id;

        }
      }
    },

    loadNextStep() {
      this.handlers = [];
      nextStepInfoViewService.nextSteps(this.flowId, null).then(response => {
        this.nextStepsCaNhan = h.findAll(
          response.data,
          item => item.stepType === constants.STEP.STEP_TYPE.CANHAN
        );
        this.nextStepsDonVi = h.findAll(
          response.data,
          item => item.stepType === constants.STEP.STEP_TYPE.DONVI
        );
        h.each(this.nextStepsCaNhan, item => this.loadUsersForNextStep(item));
        h.each(this.nextStepsDonVi, item => this.loadDeptForNextStep(item));
      });
    },

    loadUsersForNextStep(nextStep) {
      userDeptRoleViewService
        .findAllActiveForStepInfo(nextStep.vbStepInfoId)
        .then(response => {
          this.handlers = this.handlers.concat(
            h.collect(response.data, userView => {
              return {
                id: userView.id,
                userView: userView,
                stepId: nextStep.id
              };
            })
          );
        });
    },

    loadDeptForNextStep(nextStep) {
      if (!nextStep.deptId) return;

      departmentService.findById(nextStep.deptId).then(response => {
        this.deptForNextStep = this.deptForNextStep.concat({
          id: response.data.id,
          deptName: response.data.deptName,
          stepId: nextStep.id
        });
      });
    },

    receiverHandlerLabel(option) {
      let usersView = option.userView;

      return `${usersView.fullName} (${usersView.positionName} - ${
        usersView.deptName
      })`;
    },

    loadFlows() {
      return flowService
        .findAll(
          {deptId: this.deptId, flowType: constants.FLOW_TYPE.VB_DEN},
          {sort: "flowName,asc"}
        )
        .then(response => {
          this.flows = response.data;
          this.defaultFlow = this.flows.find(
            flow => flow.isDefault == constants.VB_FLOW.DEFAULT.IS_DEFAULT
          );
          if (this.defaultFlow) this.form.flowId = this.defaultFlow.id;
        });
    },

    loadCategories() {
      h.each(
        [
          constants.CATEGORY_GROUP_CODE.PRIORITY,
          constants.CATEGORY_GROUP_CODE.DOC_TYPE,
          constants.CATEGORY_GROUP_CODE.DOC_RELATION_TYPE,
          constants.CATEGORY_GROUP_CODE.PROCESS_LEVEL
        ],

        item => {
          categoryViewService
            .findAll(
              {groupCode: item},
              {sort: "order,asc", page: 0, size: 1000}
            )
            .then(response => {
              switch (item) {
                case constants.CATEGORY_GROUP_CODE.PRIORITY:
                  // set default
                  this.priority = h.find(
                    response.data,
                    priority =>
                      priority.categoryCode === "BT" ||
                      priority.categoryName.toUpperCase() === "BÌNH THƯỜNG"
                  );
                  return (this.priorities = response.data);

                case constants.CATEGORY_GROUP_CODE.DOC_TYPE:
                  return (this.docTypes = response.data);

                case constants.CATEGORY_GROUP_CODE.DOC_RELATION_TYPE:
                  return (this.docRelationTypes = response.data);

                case constants.CATEGORY_GROUP_CODE.PROCESS_LEVEL:
                  // set default
                  this.processLevel = h.find(
                    response.data,
                    processLevel =>
                      processLevel.categoryCode === "NĐB" ||
                      processLevel.categoryName.toUpperCase() === "NHẬN ĐỂ BIẾT"
                  );
                  return (this.processLevels = response.data);
              }
            });
        }
      );
    },

    escapeKeyListener: function (evt) {
      if (evt.keyCode === 27) {
        this.cancel();
      } else if (evt.keyCode === 118) {
        this.forwardToNextHandler(null);
      } else if (evt.keyCode === 119) {
        this.forwardToNextHandler({flag: "isCopyNew"});
      } else if (evt.keyCode === 120) {
        this.forwardToNextHandler({flag: "isCreateNew"});
      }
    },

    customDeptName(department) {
      return (
        `${department.deptName} - ${department.deptCode}` +
        (department.parentName
          ? ` (${department.parentName}` +
          (department.tenantCode !== 'vinatabatrading.com.vn' ? ` - ${department.parentId}` : '') +
          `)`
          : '')
      )
    },

    getVbAttachmentAsBase64() {
      return vbAttachmentTokenService.downloadVbAttachmentForVTAsBase64(this.vbAttachment.id)
    },

    signVbAttachmentBCY() {
      return vbAttachmentTokenService
        .getToken(this.vbAttachment.id).then(res => {
          let baseUrl = constants.BASE_SERVICE_URL;
          if (baseUrl.startsWith('https', 0)){
            baseUrl = baseUrl.replace('https', 'http');
          }

          //build url download file;
          let fileUrl = `${
            baseUrl
          }vbAttachmentToken/secure/downloadFileOutgoingDocForVT?token=${
            res.data.token
          }&tenantCode=${this.tenantCode}`;

          //build handle-url để handle sau khi ký xong file;
          let handlerCallbackUrl = `${
            baseUrl
          }vbAttachment/uploadForwardLDBanCycp?token=${res.data.token}&vbAttachmentId=${this.vbAttachment.id}&tenantCode=${this.tenantCode}`;
          this.isProcessing = false;

          return signBcycpTokenService
            .signPdf({
              fileUrl: fileUrl,
              FileUploadHandler: handlerCallbackUrl,
              docCode: this.form.docCode,
              docDate: this.form.docDate
            })
            .then(response => {
                console.log(`----- Ky thanh cong -----`);
              }
            )
            .catch((err) => {
              this.notify(
                "Lỗi",
                "Upload file ký số không thành công. Vui lòng thử lại!",
                "error",
                4000
              );
              throw err;
            })
      })
    },

    signVbAttachment(tokenImages) {
      return this.getCert()
        .then(cert => this.getVbAttachmentAsBase64()
          .then(response => ({
            cert: cert,
            base64String: response.data
          }))
        )
        .then(response => this.signedWithToken2_(response.cert,response.base64String, 0, tokenImages))
        .then(response => {
          let signResult = response;
          console.log('response',response);
          if (signResult.Status === constants.TOKEN_CA.STATUS.SUCCESS) {
            console.log(`----- Ky thanh cong -----`)
            return attachmentService.uploadSignedPdfForwardLD(
              signResult.FileDataSigned,
              this.vbAttachment.id
            )
            .then(response => response)
            .catch((err) => {
              this.notify(
                "Lỗi",
                "Upload file ký số không thành công. Vui lòng thử lại!",
                "error",
                4000
              );
              throw err;
            })
          } else {
            throw signResult.ErrorDetail
          }
        })
    },

    signVbWithoutTokenImages() {
      return this.getCert()
        .then(cert => this.getVbAttachmentAsBase64()
          .then(response => ({
            cert: cert,
            base64String: response.data
          }))
        )
        .then(response => signTokenService
          .signPdfV2({
            fileData: response.base64String,
            certSerial: response.cert.Serial,
            signDate: "",
            fieldName: "",
            typeSign: "4",
            page: "1",
            px: "0",
            py: "0",
            pw: "1",
            ph: "1",
            imageData: constants.TRANSPARENT_BASE64
          }))
        .then(response => {
          let signResult = response.data;
          if (signResult.Status === constants.TOKEN_CA.STATUS.SUCCESS) {
            console.log(`----- Ky thanh cong -----`)
            return attachmentService.uploadSignedPdfForwardLD(
              signResult.FileDataSigned,
              this.vbAttachment.id
            )
              .then(response => response.data)
              .catch((err) => {
                this.notify(
                  "Lỗi",
                  "Upload file ký số không thành công. Vui lòng thử lại!",
                  "error",
                  4000
                );
                throw err;
              })
          } else {
            throw signResult.ErrorDetail
          }
        })
    },

    signedWithToken2_(cert, fileDataInBase64, index, tokenImages) {
      console.log('--- signedWithToken2_ ...')
      console.log('- cert', cert)
      console.log('- fileDataInBase64', fileDataInBase64)
      console.log('- index', index)
      console.log('- tokenImages', tokenImages)
      let tokenImage = tokenImages[index];
      return new Promise((resolve, reject) => {
        signTokenService
          .signPdfV2({
            fileData: fileDataInBase64,
            certSerial: cert.Serial,
            signDate: null,
            fieldName: "",
            typeSign: "4",
            page: tokenImage.page.toString(),
            px: Math.round(tokenImage.px).toString(),
            py: Math.round(tokenImage.py).toString(),
            pw: Math.round(tokenImage.pw).toString(),
            ph: Math.round(tokenImage.ph).toString(),
            imageData: tokenImage.imageData.substring(
              "data:image/png;base64,".length
            )
          })
          .then(response3 => {
            let signResult = response3.data;
            if (signResult.Status === constants.TOKEN_CA.STATUS.SUCCESS) {
              console.log(`----- Ky thanh cong ${index} -----`)
              return resolve(
                index === tokenImages.length - 1
                  ? signResult
                  : this.signedWithToken2_(
                    cert,
                    signResult.FileDataSigned,
                    index + 1,
                    tokenImages
                  )
              );
            } else {
              this.notify(
                "Lỗi",
                errorMessageFilter({
                  errorCode: "tokenCA.signPdfError",
                  params: [signResult.ErrorDetail]
                }),
                "error",
                4000
              );
              console.log(`----- Ky loi ${index}-----`);
              console.log('signResult', signResult)
              reject(new Error("tokenCA.signPdfError"));
            }
          })
          .catch(error => {
            return reject(error)
          });
      });
    },

    getCert() {
      return signTokenService
        .getCert("")
        .then(response2 => response2.data)
        .catch(() => {
          this.notify(
            "Lỗi",
            errorMessageFilter({ errorCode: "tokenCA.error" }),
            "error",
            4000
          );
        });
    },

    loadIsSignBeforeForwardLd() {
      departmentService.findById(this.deptId)
      .then(response => {
        const dept = response.data;
        this.forwardDept = dept;
        const isSignBeforeForwardLd = dept && constants.DEPARTMENT.SIGN_BEFORE_FORWARD_LD.ACTIVE === dept.isSignBeforeForwardLd;
        const needToSignMobiCa = dept && constants.DEPARTMENT.CA_PROVIDER.MOBI_CA === dept.caProvider && constants.DEPARTMENT.NEED_TO_SIGNCA.ACTIVE === dept.needToSignCa ? 1 : 0;
        const needToSignBCYCa = dept && constants.DEPARTMENT.CA_PROVIDER.BAN_CYCP === dept.caProvider && constants.DEPARTMENT.NEED_TO_SIGNCA.ACTIVE === dept.needToSignCa ? 1 : 0;

        this.isSignBeforeForwardLd = isSignBeforeForwardLd && needToSignMobiCa;
        this.isSignBeforeForwardLdBCY = isSignBeforeForwardLd && needToSignBCYCa;
      })
    },

    findCustomRequiredField(input) {
        let getResult = h.find(this.customRequiredFields, result => result === input);
        return getResult === input;
    },

    setDynamicStylingRequired(bool) {
      if(bool){
        return "label-input field-needed";
      }
      else {
        return "label-input";
      }
    },
// load action log lấy lý do từ chối
    loadActionLogs() {
      let promise;
      if(this.isConfigLD) {
        promise = actionLogService
          .findAllByVbIncomingDocForConfigLD(this.id, this.id, {
            sort: "createTime,desc",
            page: 0,
            size: 1000
          })
      } else {
        promise = actionLogService
          .findAllByVbIncomingDoc(this.id, this.id, {
            sort: "createTime,desc",
            page: 0,
            size: 1000
          })
      }
      return promise.then(response => {
        this.actionLogs = response.data;
        this.commentLog = this.actionLogs.at(0).comment;
        return this.actionLogs;
      });
    },

    loadShareLibrary() {
      return vShareLibService
        .findAll({
          code: this.docTypes.find(i => i.id === this.form.docTypeId).categoryCode
        })
        .then(async response => {
          let items = response.data;
          const resAttachment = await attachmentService.findById(items[0].attachmentId);
          this.vbShareLibAttchment = resAttachment.data
        });
    },
    changeDocTypeId() {
      this.loadShareLibrary();
    },

    async submitDynamicFieldForm(formDynamic) {
      try {
        this.loadingOpenDynamicFieldFormDialog = true
        vbAttachmentTokenService
          .getToken(this.vbShareLibAttchment.id)
          .then(async response => {
            const path = buildAttachmentURL(
              response.data.token,
              {
                type: this.DOWNLOAD_OPTION.TYPE.ORIGINAL
              }
            )
            getBinaryContent(path, async (error, content) => {
              if (error) {
                throw error;
              }
              const zip = new PizZip(content);
              const doc = new Docxtemplater(zip, {paragraphLoop: true, linebreaks: true});
              doc.render({
                ...formDynamic
              });
              const out = doc.getZip().generate({
                type: 'blob',
                mimeType:
                  'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
              });

              const file = new File([out], this.vbShareLibAttchment.fileName, {
                type: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
              });
              const formData = new FormData();
              formData.append('file', file);
              formData.append('objectType', 1);
              attachmentService.convertWordToPdf(formData).then(response => {
                this.vbAttachment = response.data
                this.isOpenDynamicFieldFormDialog = false;
                this.loadingOpenDynamicFieldFormDialog = false
                this.$message.success(
                  errorMessageFilter({
                    errorCode: "attachment.convertSuccess"
                  })
                );
              })

            })
          })
      }catch (err) {
        this.$message.error(errorMessageFilter({
          errorCode: "attachment.convertFailed"
        }))
        this.loadingOpenDynamicFieldFormDialog = false
      }
    },
  }
};
</script>
<style scoped></style>



// WEBPACK FOOTER //
// src/views/doc-in/Create.vue